import {useEffect, useState} from 'react';
import SegnalazioneDetailSection from "./RiepilogoSegnalazione/SegnalazioneDetailSection";
import SegnalazioniStructureService from '../../services/controllers/segnalazioni-services/SegnalazioniStructureService';
import SegnalazioneDetailButtons from '../../shared/atomic_components/button/SegnalazioneDetailsButton';
import SegnalazioneSystemInformationsLabels from '../../shared/variables/SegnalazioneSystemInformationsLabels';
import SegnalazioneFlowStateLabels from '../../shared/variables/SegnalazioneFlowStateLabels';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModalAssegnaSegnalazione from "./ModalAssegnaSegnalazione";
import ModalRifiutaSegnalazione from "./ModalRifiutaSegnalazione";
import User from '../../services/models/output-objs/User';
import CONSTANTS from '../../shared/utils/Constants';
import SegnalazioneFlowState from '../../shared/variables/SegnalazioneFlowState';

type SegnalazioneDetailType = {
    notificationFunctions : any,
    user : User
}

const SegnalazioneDetail = ({notificationFunctions, user} : SegnalazioneDetailType) => {

    const [segnalazione, setSegnalazione] = useState(readSegnalazione())
    const [segnalazioneSections, setSegnalazioneSections] = useState<string[]>([])
    const [segnalazioneLabelsStructure, setSegnalazioneLabelStructure] = useState<{[key : string] : any}>({})
    const [currentSection, setCurrentSection] = useState("")
    const [showSegnalazioneDetails, setShowSegnalazioneDetails] = useState(true)
    const [openModalAssegnaSegnalazione, setOpenModalAssegnaSegnalazione] = useState(false)
    const [openModalRifiutaSegnalazione, setOpenModalRifiutaSegnalazione] = useState(false)
    
    useEffect(() => {
        const segnalazioneSections = Object.keys(segnalazione)
        setSegnalazione(segnalazione)
        setSegnalazioneSections(segnalazioneSections)
        setSegnalazioneLabelStructure(SegnalazioniStructureService.getLabelsOfStructure())
        setCurrentSection(segnalazioneSections[0])
        if (sessionStorage.getItem('successCreatingSegnalazione')) {
            notificationFunctions.setSuccessMessage('Segnalazione creata con successo')
            sessionStorage.removeItem('successCreatingSegnalazione')
        }

    }, []) 

    function toggleShowSegnalazioneDetails() {
        setShowSegnalazioneDetails(!showSegnalazioneDetails)
    }

    function handleOpenModalRifiutaSegnalazione() {
        setOpenModalRifiutaSegnalazione(true)
    }

    function handleCloseModalRifiutaSegnalazione() {
        setOpenModalRifiutaSegnalazione(false)
    }

    function handleOpenModalAssegnaSegnalazione() {
        setOpenModalAssegnaSegnalazione(true)
    }

    function handleCloseModalAssegnaSegnalazione() {
        setOpenModalAssegnaSegnalazione(false)
    }


    function readSegnalazione() {
        let segnalazione
        if (sessionStorage.getItem('arrivedFromSegnalazioneCreate') === 'true'){
            segnalazione = JSON.parse(sessionStorage?.getItem('newSegnalazione') || '{}')
            if(sessionStorage.getItem('SegnalazioneInviataAzione')=='rettifica'){
                segnalazione.systemInformations.state = "Integrazione"
            }
            else if(Object.keys(segnalazione).length){
                segnalazione.systemInformations.state = "In compilazione"
            }
        }
        else{
            segnalazione = JSON.parse(sessionStorage?.getItem('segnalazioneGetStorById') || '{}')
        }
        return segnalazione
    }

    function readArricchimentoStructure() {
        const structure = SegnalazioniStructureService.getArricchimentoStructure();
        return structure.section
    }

    function readFunzionarioStructure() {
        const structure = SegnalazioniStructureService.getFunzionarioStructure();
        return structure.section
    }

    function readOsservatoreStructure() {
        const structure = SegnalazioniStructureService.getOsservatoreStructure();
        return structure.section
    }

    function readFunzionarioLeaderStructure() {
        const structure = SegnalazioniStructureService.getFunzionarioLeaderStructure();
        return structure.section
    }

    function readNotaMabStructure() {
        const structure = SegnalazioniStructureService.getNotaMabStructure();
        return structure.section
    }

    function getParameter(field : any){
        if(field === 'identificativo' && !user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)){
            if(segnalazione['identitaSegnalante'] && segnalazione['identitaSegnalante']['persFisicaSegnalante'] && segnalazione['identitaSegnalante']['persFisicaSegnalante']['numeroProtocolloSegnalante'])
                return segnalazione['identitaSegnalante']['persFisicaSegnalante']['numeroProtocolloSegnalante']
            else
                return ''
        }
        else if(field === 'state' && !user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)){
            if(segnalazione['systemInformations'][field] != SegnalazioneFlowState.IN_COMPILAZIONE &&
            segnalazione['systemInformations'][field] != SegnalazioneFlowState.PROTOCOLLATA &&
            segnalazione['systemInformations'][field] != SegnalazioneFlowState.FASE_DI_RETTIFICA &&
            segnalazione['systemInformations'][field] != SegnalazioneFlowState.RETTIFICATA &&
            segnalazione['systemInformations'][field] != SegnalazioneFlowState.CANCELLATA &&
            segnalazione['systemInformations'][field] != SegnalazioneFlowState.DA_COMPLETARE){
                return 'Inviata'
            }
            else{
                return segnalazione['systemInformations'][field]
            }
        }
        else
            return segnalazione['systemInformations'][field]
    }

    function handleChangeSection(section : any) {
        setCurrentSection(section);
    };

    function dateConvert(date : string){
        if(date){
            let newDate = new Date(date)
            return newDate.toLocaleDateString()
        }
        else 
            return null
    }
    

    return (
        <div className="mt-5">
            <ModalAssegnaSegnalazione
                openModalAssegnaSegnalazione={openModalAssegnaSegnalazione}
                handleCloseModalAssegnaSegnalazione={handleCloseModalAssegnaSegnalazione}
            />
            <ModalRifiutaSegnalazione
                openModalRifiutaSegnalazione={openModalRifiutaSegnalazione}
                handleCloseModalRifiutaSegnalazione={handleCloseModalRifiutaSegnalazione}
            />
            <div className="row">
                <div className="row font-x-large-custom my-auto">Riepilogo segnalazione</div>
                <SegnalazioneDetailButtons
                    // handleOpenModalAccettaSegnalazione={handleOpenModalAccettaSegnalazione}
                    handleOpenModalRifiutaSegnalazione={handleOpenModalRifiutaSegnalazione}
                    hanldeOpenModalAssegnaSegnalazione={handleOpenModalAssegnaSegnalazione}
                    segnalazione={segnalazione}
                    user = {user}
                    notificationFunctions={notificationFunctions}></SegnalazioneDetailButtons>
            </div>
            <div className="row mt-4">
                <div className="col-auto font-medium-custom text-bold color-secondary">
                    Informazioni generali
                </div>
            </div>
            <div className="row mt-4">
                <div className="card-body background-gray">
                    <div className="card-body background-white">
                        <div className="row">
                            {Object.keys(segnalazione['systemInformations'])?.map(field => {
                                if (field !== 'id' && field !== 'flowDetails' && field !== 'autoritaEsteraId' && field !== 'pageNumber' && field !== 'updateReason')
                                    return <div key={field} className="col-auto margin-right-5">
                                        <div className="font-small-custom color-third">
                                            {SegnalazioneSystemInformationsLabels[field] ? SegnalazioneSystemInformationsLabels[field] : field}
                                        </div>
                                        {
                                            field == 'dataInvio' ? 
                                            <div className="mt-1 font-medium-custom">
                                                {SegnalazioneFlowStateLabels[segnalazione['systemInformations'][field]] ? SegnalazioneFlowStateLabels[segnalazione['systemInformations'][field]] : dateConvert(segnalazione['systemInformations'][field])}
                                            </div> 
                                            :
                                            <div className="mt-1 font-medium-custom">
                                                {SegnalazioneFlowStateLabels[segnalazione['systemInformations'][field]] ? SegnalazioneFlowStateLabels[segnalazione['systemInformations'][field]] : getParameter(field)}
                                            </div>
                                        }
                                    </div>
                            })}
                        </div>
                        {segnalazione['systemInformations']['updateReason'] ? 
                            <div className="row mt-3">
                                <div className="font-small-custom color-third">
                                    Giustificazione
                                </div>
                                <div className="mt-1 font-medium-custom">
                                    {segnalazione['systemInformations']['updateReason']}
                                </div> 
                            </div>: 
                            <></>
                        }
                       
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-auto font-medium-custom text-bold color-secondary">
                    Dettagli Segnalazione
                </div>
                <div className="d-flex col-auto text-bold pointer color-primary">
                    <span onClick={() => toggleShowSegnalazioneDetails()}>
                        {
                            showSegnalazioneDetails ?
                                <KeyboardArrowUpIcon/>
                                :
                                <ExpandMoreIcon/>
                        }
                    </span>
                </div>
            </div>
            {showSegnalazioneDetails ?
                <><div className="row mt-4">
                    {segnalazioneSections.map(section => {
                        if (section !== 'systemInformations')
                            return <div key={section}
                                        className={currentSection === section ? "col-md-2 col-sm-6 card-body text-center text-selected background-gray" : "card-body text-center pointer col-md-2 col-sm-6"}>
                                <div onClick={() => handleChangeSection(section)}>
                                    {segnalazioneLabelsStructure[section].label}
                                </div>
                            </div>
                    })}
                </div>
                {
                    segnalazioneSections.map(section => {
                        return <div key={section}>
                            {currentSection === section ?
                                <SegnalazioneDetailSection
                                    segnalazioneSectionLabelsStructure={segnalazioneLabelsStructure[section]}
                                    segnalazioneSection={segnalazione[section]}
                                    state = {segnalazione['systemInformations']['state']}/>
                                :
                                <></>
                            }
                        </div>
                    })
                }
                </> : <></>
            }
        </div>
    );
}

export default SegnalazioneDetail;
